export const leepayFormat = (value: string) => {
  if(value=='ROOT') {
    return 'Leepay';
  }
  else{
    return value;
  }
};
